import moment from "moment";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { unifiedEnvConfig } from "../../../../constants/api-endpoint";
import { httpGet } from "../../../../utility/requestHelper";
import { CustomBSDropdown } from "../../../Shared";
import TwitterFeeds from "../TwiterFeeds";
import AnalysisWidget from "./AnalysisWidget";
export const TwitterInsights = ({
  widgetParams,
  feedsParams,
  setFeedsParams,
  setShowFeedsList,
  applyFilterTS,
  widgetList,
  startRange,
  endRange,
}) => {
  const [topicId, setTopicId] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState();
  const [apiInProgress, setApiInProgress] = useState(false);
  const [tabData, setTabData] = useState([]);
  const [widgetApiInProgress, setWidgetApiInProgress] = useState(false);
  const [optList, setOptList] = useState([]);
  const [topicList, setTopicList] = useState([]);

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};

  if (!widgetParams || !Object.keys(widgetParams).length) {
    return null;
  }
  const vertical = widgetParams.selectedVertical;
  let tempWidgetList = [...widgetList];
  if (Array.isArray(vertical)) {
    tempWidgetList = tempWidgetList.filter((w) => {
      if (
        vertical.indexOf(w.type.toString()) !== -1 ||
        vertical.indexOf(w.type) !== -1
      ) {
        return w;
      }
      return null;
    });
  }
  const dropDown = () => {
    return (
      <CustomBSDropdown
        config={{
          name: "topic",
          options: optList,
          defaultOption: optList && optList[0],
        }}
        selectedItem={selectedFilter ? selectedFilter : optList[0]}
        onSelect={setSelectedFilter}
      />
    );
  };
  return (
    <>
      <div style={{ width: "100%" }} className="twi-dd-div">
        {dropDown()}
      </div>
      <React.Fragment key={vertical}>
        {tempWidgetList &&
          tempWidgetList.map((w) => {
            return (
              <AnalysisWidget
                widgetParams={{ ...w, ...widgetParams }}
                feedsParams={feedsParams}
                setFeedsParams={setFeedsParams}
                setShowFeedsList={setShowFeedsList}
                applyFilterTS={applyFilterTS}
                topicId={topicId}
                twitterFeeds
                endRange={endRange}
                startRange={startRange}
                selectedPieEntity={selectedFilter}
                tabData={tabData}
                widgetApiInProgress={widgetApiInProgress}
              />
            );
          })}
        <div className="col-md-12">
          <div className="col-md-12">
            <TwitterFeeds
              startRange={startRange}
              endRange={endRange}
              widgetList={{ ...widgetList }}
              setTopicId={setTopicId}
              topicId={topicId}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
              setTabData={setTabData}
              tabData={tabData}
              setWidgetApiInProgress={setWidgetApiInProgress}
              widgetApiInProgress={widgetApiInProgress}
              setOptList={setOptList}
              setTopicList={setTopicList}
              topicList={topicList}
            />
          </div>
        </div>
      </React.Fragment>
    </>
  );
};
